import { createAction } from '@reduxjs/toolkit';
import { StaticPageSimple } from '../../services/staticPages/staticPages';

export const setHeaderVisibility = createAction<boolean>('layout/setHeaderVisibility');
export const setCookieVisibility = createAction<boolean>('layout/setCookieVisibility');
export const setPages = createAction<StaticPageSimple[]>('layout/setPages');
